import { securePostRequest } from './request'

export const getPersonalPlans = async () => {
  const result = await securePostRequest('stripe/personal/plans')

  return result
}
